export const ROLES = {
  SUPER_ADMIN: 'super admin',
  PRIMARY: 'primary',
  PARTNER: 'partner',
  CHILD: 'child',
} as const;

export type RoleType = typeof ROLES[keyof typeof ROLES];
